export default "__VITE_ASSET__By7VdVlx__"